import { toast } from "react-toastify";

import api from "../api";

type EditContactMethodsParams = {
  body: NextApp.UseTermBody;
  options?: {
    onInit?: () => void;
    onSuccess?: () => void;
    onError?: (error: any) => void;
    onFinally?: () => void;
  };
};
async function editAcceptedContatcMethods(body: EditContactMethodsParams["body"], options?: EditContactMethodsParams["options"]) {
  if (body.useTerm?.id === undefined || body.useTerm?.updatedAt === undefined) return toast.error("Termos de uso inválidos. Não foi possível salvar.");

  options?.onInit?.();

  try {
    await api.post("useTerm/authorization/save", body);
    options?.onSuccess?.();
    // toast.success("Autorização de uso de termos salva com sucesso");
  } catch (error) {
    console.error("Error saving use term authorization: ", error);
    options?.onError?.(error);
    toast.error("Erro ao salvar autorização de uso de termos");
  } finally {
    options?.onFinally?.();
    console.log("Edit contact methods mutation completed with body: ", body);
  }
}

export const useTermMutations = {
  editAcceptedContatcMethods
};
